/**
 * <SessionActivityRow> — one "Travail validé / à faire" line (molecule, L0.1).
 *
 * The big count + the activity-template icon + the activity label, mirroring the legacy
 * `LiveReportActivityItem`. Composes DS atoms only — `<Row>`, `<Text>`, `<ImageIcon>`. No hex.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { ImageIcon } from "../../atoms/icons/ImageIcon"
import { Text } from "../../atoms/typography/Text"
import { type UILiveSessionReportActivity } from "../../../ports/primary/ui/types"

export type SessionActivityRowProps = {
    activity: UILiveSessionReportActivity
    testID?: string
}

export function SessionActivityRow(props: SessionActivityRowProps) {
    const { activity, testID } = props
    const { count, label, iconUrl } = activity

    return (
        <Row gap="3" align="center" testID={testID}>
            <Text size="text-3xl" weight="extrabold">
                {count}
            </Text>
            <ImageIcon uri={iconUrl} size={40} />
            <Text size="text-lg" weight="bold" style={styles.shrink}>
                {label}
            </Text>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    shrink: {
        flexShrink: 1,
    },
}))
